const formatedDateTime = ( date = new Date() ) => { // Returns a date time in YYYY-MM-DD hh:mm:ss format. If no date time is given, returns current date time
    const padL = (nr, len = 2, chr = `0`) => `${nr}`.padStart(len, chr);
    return `${date.getFullYear()}-${
        padL(date.getMonth()+1)}-${
        padL(date.getDate())} ${
        padL(date.getHours())}:${
        padL(date.getMinutes())}:${
        padL(date.getSeconds())}`;
};

// Returns a date in default format YYYY-MM-DDTHH:mm:ssZ
const formatedDateTimeISO = ( date = new Date, dateSeparator = '-', timeSeparator = ':', closingDateSeparator = 'T', closingTimeSeparator = 'Z' ) => {
    if ( !isADateObject( date) ) {
        console.error( "formatDate function needs a date object, or nothing, as an argument." );
    }

    return (
        date.getFullYear() + dateSeparator +
        addLeadingZeros( date.getMonth() + 1 ) + dateSeparator +
        addLeadingZeros( date.getDate() ) + closingDateSeparator +
        addLeadingZeros( date.getHours() ) + timeSeparator +
        addLeadingZeros( date.getMinutes() ) + timeSeparator +
        addLeadingZeros( date.getSeconds() ) + closingTimeSeparator ); 
}

// Retorna un objeto con los días, horas, minutos y segundos de diferencia entre ambas fechas
const daysDiff = (firstDate, secondDate) => {
    if (!isADateObject(firstDate) || !isADateObject(secondDate)) {
        console.error('dateDiff arguments must be Date objects.');
        return null;
    }
    const diffTime = firstDate.getTime() < secondDate.getTime() ? secondDate.getTime() - firstDate.getTime() : firstDate.getTime() - secondDate.getTime();
    const daysDec = diffTime  / (1000 * 60 * 60 * 24);
    const daysInt = Math.floor(daysDec);
    const hoursDec =  (daysDec - daysInt) * 24;
    const hoursInt =  Math.floor(hoursDec);
    const minutesDec = (hoursDec - hoursInt) * 60;
    const minutesInt = Math.floor(minutesDec);
    const secondsDec = (minutesDec - minutesInt) * 60;
    const secondsInt = Math.floor(secondsDec);
    return {
        days: daysInt,
        hours: hoursInt,
        minutes: minutesInt,
        seconds: secondsInt
    };
};

const addLeadingZeros = ( number ) => ('0' + number).slice( -2 );

const isADateObject = ( object ) => Object.prototype.toString.call( object ) === '[object Date]';

export { formatedDateTime, formatedDateTimeISO, daysDiff };
